import { render, staticRenderFns } from "./PatientCenterInfoBarChart.vue?vue&type=template&id=6ae7534b"
import script from "./PatientCenterInfoBarChart.vue?vue&type=script&lang=ts"
export * from "./PatientCenterInfoBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports